module.exports = __webpack_public_path__ + "static/assets/d8e2d86b37df007b3bf56e8b4bd9daa0.svg";